<template>
  <vs-table-m
    @change-page="handleChangePage"
    :sst="true"
    @selected="goToItemClicked"
    :total="result.total"
    :maxItems="pageSize"
    :data="result.items"
    :pagination="pagination"
    class="mt-10"
  >
    <template slot="header">
      <h4 class="m-2 my-4">{{ result.total || '' }} Coming soon {{ contentType }}s</h4>
    </template>
    <template slot="thead">
      <vs-th sort-key="name">Name</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].name">{{ data[indextr].name}}</vs-td>
      </vs-tr>
    </template>
  </vs-table-m>
</template>
<script>

import VsTableM from "@/components/VsTableM";

export default {
  components: {
    VsTableM
  },
  props:{
    handleChangePage: {
      type: Function,
      required: false,
      default: () => {
        return () => {}
      }
    },
    result: Object,
    contentType: String,
    pagination: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      }
    }
  },
  data: () => {
    return {
      pageSize: 5,
      page: 1,
      imagesLoaded: {}
    }
  },
  methods: {
    goToItemClicked(e) {
      let path = ''
      switch (this.contentType) {
        case 'course':
        case 'bootcamp':
          path = `edit-${this.contentType.toLowerCase()}`
          break;
        case 'learning path':
          path = 'edit-lp'
          break;
      }
      this.$router.push({ name: path, params: { id: e.id } })
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>